"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskDate = void 0;
var maskDate = function (input, format) {
    var dateParts = [];
    var delimiters = [];
    if (format
        .replace(/\W/g, '')
        .split('')
        .filter(function (v) { return !['y', 'm', 'd'].includes(v.toLowerCase()); }).length > 0) {
        throw new Error('Invalid format');
    }
    var formatNumericArray = format
        .split('')
        .map(function (f) { return (['y', 'm', 'd'].includes(f.toLowerCase()) ? '9' : f); });
    var i = 0;
    formatNumericArray.forEach(function (f) {
        // check if character is a digit
        if (/^\d$/.test(f)) {
            if (dateParts.length - 1 === i) {
                dateParts[i] += 1;
            }
            else {
                dateParts.push(1);
            }
        }
        else {
            i++;
            delimiters.push(f);
        }
    });
    var cleanedInput = input.trim().replace(/\D/g, '');
    var output = '';
    var last = 0;
    dateParts.forEach(function (g, index) {
        var end = last + g;
        if (end >= cleanedInput.length) {
            output += cleanedInput.substring(last);
        }
        else {
            output += cleanedInput.substring(last, last + g);
        }
        // insert delimiter at current position if any
        if (delimiters.length > index) {
            output += delimiters[index];
        }
        last += g;
    });
    return output;
};
exports.maskDate = maskDate;
